var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDespues({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_473_6055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8726 15.3097L20.8726 15.3097H20.8739C22.6678 15.3097 24.3883 16.0224 25.6568 17.2908C26.9253 18.5593 27.6379 20.2798 27.6379 22.0737V22.1837H27.7479H29.5078C29.5831 22.1838 29.6567 22.2062 29.7193 22.248C29.7819 22.2899 29.8307 22.3494 29.8595 22.419C29.8883 22.4885 29.8959 22.5651 29.8812 22.639C29.8665 22.7128 29.8303 22.7807 29.7771 22.834L27.0351 25.5759L27.0349 25.5762C26.9996 25.6117 26.9576 25.6399 26.9113 25.6591C26.8651 25.6784 26.8155 25.6883 26.7654 25.6883C26.7153 25.6883 26.6657 25.6784 26.6195 25.6591C26.5732 25.6399 26.5312 25.6117 26.4959 25.5762L26.4957 25.5759L23.7537 22.834C23.7005 22.7807 23.6643 22.7128 23.6496 22.639C23.6349 22.5651 23.6425 22.4885 23.6713 22.419C23.7001 22.3494 23.7489 22.2899 23.8115 22.248C23.8741 22.2062 23.9477 22.1838 24.023 22.1837H25.7839H25.8939V22.0737C25.8939 21.0809 25.5995 20.1103 25.0479 19.2848C24.4963 18.4592 23.7123 17.8158 22.795 17.4358C21.8777 17.0559 20.8683 16.9565 19.8945 17.1502C18.9208 17.3439 18.0263 17.822 17.3242 18.524C16.6222 19.2261 16.1441 20.1206 15.9504 21.0944C15.7567 22.0682 15.8561 23.0775 16.236 23.9948C16.616 24.9121 17.2594 25.6961 18.0849 26.2477C18.9105 26.7993 19.881 27.0937 20.8739 27.0937H21.8541C22.0798 27.1014 22.2938 27.1963 22.4509 27.3585C22.6085 27.5212 22.6966 27.7388 22.6966 27.9652C22.6966 28.1917 22.6085 28.4092 22.4509 28.5719C22.2938 28.7342 22.0798 28.8291 21.8541 28.8367L20.8739 28.8367L20.8726 28.8367C19.9775 28.8475 19.0892 28.6806 18.2592 28.3455C17.4291 28.0104 16.6738 27.514 16.0371 26.8848C15.4003 26.2557 14.8947 25.5065 14.5497 24.6805C14.2047 23.8546 14.027 22.9683 14.027 22.0732C14.027 21.1781 14.2047 20.2919 14.5497 19.4659C14.8947 18.64 15.4003 17.8907 16.0371 17.2616C16.6738 16.6325 17.4291 16.136 18.2592 15.8009C19.0892 15.4659 19.9775 15.2989 20.8726 15.3097Z",
    fill: "#636363",
    stroke: "#F4F4F4",
    strokeWidth: 0.22
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_6055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDespues);
export default __webpack_public_path__ + "static/media/Despues.fdfe095f3509eeb298d2e8f0203dd132.svg";
export { ForwardRef as ReactComponent };